import { render, staticRenderFns } from "./vip_person.vue?vue&type=template&id=20c1fbe8&scoped=true&"
import script from "./vip_person.vue?vue&type=script&lang=js&"
export * from "./vip_person.vue?vue&type=script&lang=js&"
import style0 from "./vip_person.vue?vue&type=style&index=0&id=20c1fbe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1fbe8",
  null
  
)

export default component.exports